var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.459,
    height: 30.503,
    viewBox: "0 0 29.459 30.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    transform: "translate(-3598.271 -4850.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    transform: "translate(-13.342 -6.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M4138.168,2427.257h-24.362a2.549,2.549,0,0,1-2.549-2.548v-6.589a2.549,2.549,0,0,1,5.1,0v4.041h19.265v-4.041a2.548,2.548,0,1,1,5.1,0v6.589A2.548,2.548,0,0,1,4138.168,2427.257Z",
    transform: "translate(-499.645 2460.176)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right-from-bracket-solid",
    d: "M21.046,8.7,12.248.4A1.466,1.466,0,0,0,9.775,1.466l-.006,4.4H1.955A1.954,1.954,0,0,0,0,7.815v3.907a1.955,1.955,0,0,0,1.955,1.954H9.77l.006,4.341a1.466,1.466,0,0,0,2.473,1.066l8.8-8.3A1.446,1.446,0,0,0,21.046,8.7Z",
    transform: "translate(3635.761 4856.93) rotate(90)",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.89c6ccebd2a6ea96a962863ae6a6d9bd.svg";
export { ForwardRef as ReactComponent };